import React from 'react';

const ResultsOverview = ({resultSets, strNumGames, changeNumGames, sport}) => {

    if(resultSets && resultSets.hasOwnProperty('type')){
        const overviewObj = {
            "last5": 'L5',
            "last10": 'L10',
            "last15": 'L15',
            "last20": 'L20',
            "last30": 'L30'
        };

        const setNumGamesFromStr = (val) => {
            const numGames = parseInt(val.slice(1));
            changeNumGames(numGames);
        };

        return(
            <div className="w-full">
                <div className="flex">
                    {/* Labels Column */}
                    <div className="w-24 flex-shrink-0 pr-4 py-3">
                        {['inning-runs', 'quarter-points'].includes(resultSets.type) && (
                            <div className="pt-[49px]"> {/* Accounts for header height + top padding */}
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Team</div>
                                </div>
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Record</div>
                                </div>
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Hit Rate</div>
                                </div>
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        {resultSets.type === 'inning-runs' ? 'Avg Runs' : 'Avg Pts'}
                                    </div>
                                </div>
                            </div>
                        )}
                        {resultSets.type === 'totals' && (
                            <div className="pt-[49px]">
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Record</div>
                                </div>
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Hit Rate</div>
                                </div>
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Team</div>
                                </div>
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                        {sport === 'mlb' ? 'Avg Runs' : 'Avg Pts'}
                                    </div>
                                </div>
                            </div>
                        )}
                        {resultSets.type === 'spread' && (
                            <div className="pt-[49px]">
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Record</div>
                                </div>
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Hit Rate</div>
                                </div>
                                <div className="h-10 flex items-center">
                                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Avg ATS</div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Results Grid - now horizontally scrollable */}
                    <div className="flex-1 overflow-x-auto py-3 px-3">
                        <div className="flex gap-4 ">
                            {Object.entries(overviewObj).map(([gamesKey, gamesVal]) => {
                                const selectedClass = gamesVal === strNumGames ? 'ring-2 ring-brand-red-500 dark:ring-brand-red-400' : '';
                                
                                return (
                                    <div 
                                        key={gamesKey}
                                        onClick={() => setNumGamesFromStr(gamesVal)}
                                        className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-800/30 border border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-150 ${selectedClass} flex-shrink-0 min-w-[175px] max-w-[200px]`}
                                    >
                                        <div className="flex justify-center py-3 border-b border-gray-200 dark:border-gray-700">
                                            <h5 className="text-base font-bold text-gray-900 dark:text-white">{gamesVal}</h5>
                                        </div>

                                        <div className="divide-y divide-gray-200 dark:divide-gray-700">
                                            {['inning-runs', 'quarter-points'].includes(resultSets.type) && (
                                                <div className="grid grid-cols-2 divide-x divide-gray-200 dark:divide-gray-700">
                                                    {Object.entries(resultSets).map(([teamKey, teamObj]) => {
                                                        if (!['type', 'subType'].includes(teamKey)) {
                                                            return (
                                                                <div key={`${gamesKey}-${teamKey}`} className="flex flex-col">
                                                                    <div className="h-10 flex items-center justify-center">
                                                                        <div className="text-sm font-medium text-gray-900 dark:text-white">{teamKey}</div>
                                                                    </div>
                                                                    <div className="h-10 flex items-center justify-center">
                                                                        <div className="text-sm text-gray-700 dark:text-gray-300">{teamObj[gamesKey].results.record}</div>
                                                                    </div>
                                                                    <div className="h-10 flex items-center justify-center">
                                                                        <div className="text-sm text-gray-700 dark:text-gray-300">{`${teamObj[gamesKey].results.winPer}%`}</div>
                                                                    </div>
                                                                    <div className="h-10 flex items-center justify-center">
                                                                        <div className="text-sm font-medium text-gray-900 dark:text-white">{teamObj[gamesKey].average}</div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            )}

                                            {resultSets.type === 'totals' && (
                                                <div className="flex flex-col">
                                                    <div className="h-10 flex items-center justify-center border-b border-gray-200 dark:border-gray-700">
                                                        <div className="text-sm text-gray-700 dark:text-gray-300">{resultSets[gamesKey].results.record}</div>
                                                    </div>
                                                    <div className="h-10 flex items-center justify-center border-b border-gray-200 dark:border-gray-700">
                                                        <div className="text-sm text-gray-700 dark:text-gray-300">{`${resultSets[gamesKey].results.winPer}%`}</div>
                                                    </div>
                                                    <div className="grid grid-cols-2 divide-x divide-gray-200 dark:divide-gray-700">
                                                        {Object.entries(resultSets[gamesKey].average).map(([teamKey, teamAvgVal]) => (
                                                            <div key={`${gamesKey}-${teamKey}`} className="flex flex-col">
                                                                <div className="h-10 flex items-center justify-center">
                                                                    <div className="text-sm font-medium text-gray-900 dark:text-white">{teamKey}</div>
                                                                </div>
                                                                <div className="h-10 flex items-center justify-center">
                                                                    <div className="text-sm font-medium text-gray-900 dark:text-white">{teamAvgVal}</div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {resultSets.type === 'spread' && (
                                                <div className="flex flex-col divide-y divide-gray-200 dark:divide-gray-700">
                                                    <div className="h-10 flex items-center justify-center">
                                                        <div className="text-sm text-gray-700 dark:text-gray-300">{resultSets[gamesKey].results.record}</div>
                                                    </div>
                                                    <div className="h-10 flex items-center justify-center">
                                                        <div className="text-sm text-gray-700 dark:text-gray-300">{`${resultSets[gamesKey].results.winPer}%`}</div>
                                                    </div>
                                                    <div className="h-10 flex items-center justify-center">
                                                        <div className="text-sm font-medium text-gray-900 dark:text-white">{resultSets[gamesKey].average}</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                {['last5', 'last10', 'last15', 'last20', 'last30'].map(key => (
                    <div key={key} className="h-32 bg-gray-100 dark:bg-gray-800 rounded-lg animate-pulse"></div>
                ))}
            </div>
        );
    }
};

export default ResultsOverview;